import { IOption } from "../../../../../../../../../../types/Option";
import { Checkbox, Form } from "antd";

type PayersListProps = {
  options: IOption[];
  label?: string;
};

export const PayersList = ({ options, label = "Payer" }: PayersListProps) => (
  <Form.Item label={label} name="payerIds" className="payers-list mb-0">
    <Checkbox.Group options={options} />
  </Form.Item>
);
